// src/model/cache.js
// 缓存控制模块
export default {
    namespaced: true,
    state: {
        cachedViews: [],              // 缓存的页面 name 列表
        viewTimestamps: {},           // 每个缓存页面的最后访问时间
        viewScrollPositions: {}       // 每个缓存页面的滚动位置
    },
    mutations: {
        // 添加缓存并记录时间戳
        ADD_CACHE(state, viewName) {
            if (!viewName) return
            if (!state.cachedViews.includes(viewName)) {
                state.cachedViews.push(viewName)
            }
            state.viewTimestamps[viewName] = Date.now()
        },
        // 移除缓存
        REMOVE_CACHE(state, viewName) {
            state.cachedViews = state.cachedViews.filter(v => v !== viewName)
            delete state.viewTimestamps[viewName]
            delete state.viewScrollPositions[viewName]
        },
        // 检查并清除过期缓存
        CLEAR_EXPIRED(state, maxAge = 30 * 60 * 1000) { // 默认 30 分钟
            const now = Date.now()
            const originalCount = state.cachedViews.length
            let expiredViews = [];

            // 定义组件名到显示名称的映射
            const nameMap = {
                'MyCustomer': '客户列表',
                'CustomerSalesman': '我的客户',
                'AcquisitionOrder': '订单列表',
                'MyOrders': '我的订单列表',
                'ProductList': '产品列表',
                'NoticeMag': '审核管理',
            };

            state.cachedViews = state.cachedViews.filter(viewName => {
                const ts = state.viewTimestamps[viewName]
                if (!ts) return false

                // 获取该页面的自定义缓存时间设置
                let pageMaxAge = maxAge
                try {
                    const cacheSettings = JSON.parse(localStorage.getItem('pageCacheSettings') || '{}')
                    const displayName = nameMap[viewName] || viewName
                    // 首先尝试使用显示名称获取缓存设置，如果失败则使用组件名称
                    if (cacheSettings[displayName]) {
                        pageMaxAge = cacheSettings[displayName] * 60 * 1000 // 转换为毫秒

                    } else if (cacheSettings[viewName]) {
                        pageMaxAge = cacheSettings[viewName] * 60 * 1000 // 转换为毫秒

                    }
                } catch (e) {
                    console.warn('解析页面缓存设置失败:', e)
                }

                const expired = now - ts > pageMaxAge
                if (expired) {
                    delete state.viewTimestamps[viewName]
                    delete state.viewScrollPositions[viewName]
                    // 存储组件名和显示名的映射关系
                    expiredViews.push({
                        componentName: viewName,
                        displayName: nameMap[viewName] || viewName
                    });
                    console.log(`缓存页面 ${nameMap[viewName] || viewName} 已过期并被清除，设置时间: ${pageMaxAge/1000/60} 分钟`)
                }
                return !expired
            })

            const removedCount = originalCount - state.cachedViews.length
            if (removedCount > 0) {

                // 保存过期的视图名称到 localStorage，以便在页面中显示提示
                localStorage.setItem('expiredViews', JSON.stringify(expiredViews));
            } else {
                // 没有过期视图时清除标记
                localStorage.removeItem('expiredViews');
            }
        },
        // 保存页面滚动位置
        SAVE_SCROLL_POSITION(state, { viewName, scrollPosition }) {
            if (viewName && scrollPosition) {
                state.viewScrollPositions[viewName] = scrollPosition
            }
        },
        // 清除页面滚动位置
        CLEAR_SCROLL_POSITION(state, viewName) {
            if (viewName) {
                delete state.viewScrollPositions[viewName]
            }
        }
    },
    actions: {
        // 保存滚动位置的 action
        saveScrollPosition({ commit }, payload) {
            commit('SAVE_SCROLL_POSITION', payload)
        },
        // 清除滚动位置的 action
        clearScrollPosition({ commit }, viewName) {
            commit('CLEAR_SCROLL_POSITION', viewName)
        },
        // 添加缓存的 action
        addCache({ commit }, viewName) {
            commit('ADD_CACHE', viewName)
        },
        // 移除缓存的 action
        removeCache({ commit }, viewName) {
            commit('REMOVE_CACHE', viewName)
        },
        // 清除过期缓存的 action
        clearExpired({ commit }, maxAge = null) {
            if (maxAge !== null) {
                commit('CLEAR_EXPIRED', maxAge)
            } else {
                commit('CLEAR_EXPIRED')
            }
        }
    },
    getters: {
        // 获取页面缓存时间设置
        getPageCacheTime: (state) => (pageName) => {
            try {
                const cacheSettings = JSON.parse(localStorage.getItem('pageCacheSettings') || '{}')
                // 使用组件名到显示名称的映射
                const nameMap = {
                    'MyCustomer': '客户列表',
                    'CustomerSalesman': '我的客户',
                    'AcquisitionOrder': '订单列表',
                    'MyOrders': '我的订单列表',
                    'ProductList': '产品列表',
                    'NoticeMag': '审核管理',
                }

                const displayName = nameMap[pageName] || pageName
                // 首先尝试使用显示名称获取缓存设置，如果失败则使用组件名称
                return cacheSettings[displayName] || cacheSettings[pageName] || 30 // 默认30分钟
            } catch (e) {
                console.warn('获取页面缓存时间失败:', e)
                return 30 // 默认30分钟
            }
        },
        // 检查特定页面是否已缓存
        isCached: (state) => (viewName) => {
            return state.cachedViews.includes(viewName)
        }
    }
}



// WEBPACK FOOTER //
// ./src/model/cache.js